export const labelVariants = {
  rest: { translateY: '0%' },
  hover: { translateY: '100%' },
};
export const underlineVariants = {
  rest: { width: '0%' },
  hover: { width: '100%' },
  selected: { width: '100%' },
};
